import { Button as BPButton, ButtonProps, Intent } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";

import styles from "./button.module.scss";

type ButtonWithId = ButtonProps & { id?: string };

export const Button = ({ id, className, ...props }: ButtonWithId) => {
  const { minimal, outlined } = props;
  return (
    <BPButton
      id={id}
      {...(!minimal && !outlined ? { intent: Intent.PRIMARY } : {})}
      className={classNames(styles.button, className)}
      {...props}
    />
  );
};
